import { ExportOrderKey } from "../exports/export-order-key";
import { ClusterProduct } from "./cluster-product.model";

export class ImportClusterResult {
  private exportKey: ExportOrderKey;
  private adicionados: number;
  private removidos: number;
  private message: string;

  constructor() {}

  public getExportKey(): ExportOrderKey {
    return this.exportKey;
  }

  public setExportKey(exportKey: ExportOrderKey): void {
    this.exportKey = exportKey;
  }

  public getAdicionados(): number {
    return this.adicionados;
  }

  public setAdicionados(adicionados: number): void {
    this.adicionados = adicionados;
  }

  public getRemovidos(): number {
    return this.removidos;
  }

  public setRemovidos(removidos: number): void {
    this.removidos = removidos;
  }

  public getMessageResult(): string {
    return this.message;
  }

  public setMessageResult(message: string): void {
    this.message = message;
  }
}
